<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" *ngIf="person" class="mt-12 userProfilePicture">
    <ngx-avatar
        [round]="round"
        [size]="size"
        [bgColor]="bgColor"
        [fgColor]="fgColor"
        initialsSize="1"
        [src]="person.ProfileImage"
        [name]="person.DisplayName"
        textSizeRatio="2.5"
    >
    </ngx-avatar>
    <div fxLayout="column" fxLayoutGap="8px">
        <span class="text-color-80 font-weight-600 font-size-16">{{ person.DisplayName }}</span>
        <span class="text-color-60 font-weight-500 font-size-14" *ngIf="showEmail">{{ person.Email }}</span>
    </div>
</div>
